// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Json_decode from "../../../../../node_modules/@glennsl/bs-json/src/Json_decode.bs.js";
import * as OrderStateMapper from "../entity-mapper/OrderStateMapper.bs.js";
import * as ResponseHandler$Catalyst from "../../../../../node_modules/@porterin/catalyst/src/helper-modules/response-handler/ResponseHandler.bs.js";

var execute = OrderStateMapper.builder;

var OrderListRepoConfig = {
  execute: execute
};

var partial_arg = ResponseHandler$Catalyst.ResponseConverter;

var OrderListResponseConverter = partial_arg(OrderListRepoConfig, ResponseHandler$Catalyst.DefaultErrorConverter);

function execute$1(json) {
  return OrderStateMapper.FilterOrderResponseMapper.execute(json);
}

var FilterOrderConverterConfig = {
  execute: execute$1
};

function decodeNotAcceptableError(json) {
  return /* DefaultError */{
          _0: {
            title: {
              TAG: /* Custom */0,
              _0: "Invalid Input"
            },
            message: Json_decode.field("error", Json_decode.string, json)
          }
        };
}

function execute$2(data) {
  if (typeof data === "number" || data.TAG !== /* NotAcceptableEntity */3) {
    return ResponseHandler$Catalyst.DefaultErrorConverter.execute(data);
  } else {
    return decodeNotAcceptableError(data._0);
  }
}

var ErrorConverter = {
  decodeNotAcceptableError: decodeNotAcceptableError,
  execute: execute$2
};

var partial_arg$1 = ResponseHandler$Catalyst.ResponseConverter;

var FilterOrderResponseConverter = partial_arg$1(FilterOrderConverterConfig, {
      execute: execute$2
    });

export {
  OrderListRepoConfig ,
  OrderListResponseConverter ,
  FilterOrderConverterConfig ,
  ErrorConverter ,
  FilterOrderResponseConverter ,
  
}
/* OrderListResponseConverter Not a pure module */
